module.exports = __webpack_public_path__ + "models/exterior_2e17c0d90dd5c200f92a958f2829a98f.glb";